import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// --- ASCII Art Branding Console Greeting ---
console.log(
  "%c       ██╗   ██████╗  %c██████╗   ██╗\n" +
  "%c     ██╔═╝   ██╔══██╗ %c██╔══██╗   ╚═██╗\n" +
  "%c   ██╔═╝     ██║  ██║ %c██████╔╝     ╚═██╗\n" +
  "%c   ╚═██╗     ██║  ██║ %c██╔══██╗     ██═╔╝\n" +
  "%c     ╚═██╗   ██████╔╝ %c██████╔╝   ██═╔╝\n" +
  "%c       ╚═╝   ╚═════╝  %c╚═════╝   ╚═╝\n\n" +
  "%c   Davide Balice — Full-Stack & 3D Web Developer\n" +
  "%c   🚀 https://davidebalice.dev\n",
  "color: #00f2fe; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #eb4d3d; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #00f2fe; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #eb4d3d; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #00f2fe; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #eb4d3d; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #00f2fe; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #eb4d3d; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #00f2fe; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #eb4d3d; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #00f2fe; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #eb4d3d; font-weight: bold; font-family: monospace; font-size: 13px;",
  "color: #94a3b8; font-weight: 600; font-family: sans-serif; font-size: 12px;",
  "color: #00f2fe; font-family: sans-serif; font-size: 11px;"
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

reportWebVitals();
